import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { FontSizeInPx, FontWeight, Spacing } from "@snapchat/snap-design-system";

import { PageHeader } from "../../layout/components";

export const PageTitle = styled(PageHeader)`
    flex: 1;
    flex-shrink: 0;
    width: 150px;
    margin-right: ${Spacing.MD}px;
`;

export const headerSectionContainer = css`
    align-items: center;
`;

export const apiButton = css`
    span {
        font-size: ${FontSizeInPx.REGULAR}px;
        font-weight: ${FontWeight.NORMAL};
    }
`;

export const loadableContainer = css`
    width: 100%;
    padding: 0 ${Spacing.LG}px;
`;

export const buttonIcon = css`
    margin-right: 5px;
    vertical-align: text-top;
`;
